import { render, staticRenderFns } from "./Office.vue?vue&type=template&id=2a1845f4&scoped=true&"
import script from "./Office.vue?vue&type=script&lang=ts&"
export * from "./Office.vue?vue&type=script&lang=ts&"
import style0 from "./Office.vue?vue&type=style&index=0&id=2a1845f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1845f4",
  null
  
)

export default component.exports